import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

function FaqItem({ item, i }) {
  return (
    <AccordionItem value={`q${i}`} className="border-b border-[#E2E8F0]" data-testid={`faq-item-${i}`}>
      <AccordionTrigger className="text-left hover:no-underline py-5" data-testid={`faq-question-${i}`}>
        <span className="flex gap-4 items-baseline">
          <span className="font-sub text-sm text-[#E11D48] font-semibold w-6 shrink-0">{String(i + 1).padStart(2, "0")}</span>
          <span className="font-headline text-base md:text-lg font-bold text-[#0A0A0A]">{item.q}</span>
        </span>
      </AccordionTrigger>
      <AccordionContent className="pl-10 pb-6 space-y-3">
        {item.a.map((p, k) => <p key={k} className="font-body text-base text-slate-700 leading-relaxed text-justify">{p}</p>)}
        {item.list && (
          <ul className="space-y-2 mt-2">
            {item.list.map(([k, v]) => (
              <li key={k} className="font-body text-base text-slate-700 flex gap-2"><span className="text-[#E11D48]">—</span><span><strong className="text-[#0A0A0A]">{k} :</strong> {v}</span></li>
            ))}
          </ul>
        )}
      </AccordionContent>
    </AccordionItem>
  );
}

export default function FaqPage() {
  const [faq, setFaq] = useState(null);
  useEffect(() => {
    document.title = "FAQ — Le Véridique";
    window.scrollTo(0, 0);
    api.get("/faq").then((r) => setFaq(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-testid="faq-page">
        <p className="meta-label text-[#E11D48] mb-3">Foire aux questions</p>
        <h1 className="font-headline text-4xl sm:text-5xl lg:text-6xl font-black text-[#0A0A0A] mb-3">FAQ</h1>
        {faq && (
          <>
            <h2 className="font-sub text-base md:text-lg text-slate-600 mb-6">{faq.subtitle}</h2>
            <p className="font-body text-base text-slate-700 text-justify mb-10">{faq.intro}</p>
            <Accordion type="multiple" className="border-t border-[#E2E8F0]" data-testid="faq-list">
              {faq.items.map((item, i) => <FaqItem key={i} item={item} i={i} />)}
            </Accordion>
            <div className="mt-12 bg-[#0F172A] text-white rounded-2xl p-8">
              <p className="font-body text-base text-slate-300 text-justify mb-4">{faq.outro}</p>
              <p className="font-headline font-bold">{faq.signature}</p>
              <Link to="/contact" data-testid="faq-contact-link" className="inline-block mt-6 bg-[#E11D48] hover:bg-[#BE123C] transition-colors px-5 py-2.5 rounded-full font-sub text-sm font-semibold">Nous contacter</Link>
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
